// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_PO_REQUEST = 'FETCH_ACCESSORIES_PO_REQUEST';
export const FETCH_ACCESSORIES_PO_SUCCESS = 'FETCH_ACCESSORIES_PO_SUCCESS';
export const FETCH_ACCESSORIES_PO_FAILURE = 'FETCH_ACCESSORIES_PO_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_ACCESSORIES_PO_REQUEST = 'CREATE_ACCESSORIES_PO_REQUEST';
export const CREATE_ACCESSORIES_PO_SUCCESS = 'CREATE_ACCESSORIES_PO_SUCCESS';
export const CREATE_ACCESSORIES_PO_FAILURE = 'CREATE_ACCESSORIES_PO_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_PO = 'CREATE_USER_FORM_ACCESSORIES_PO';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_ACCESSORIES_PO_REQUEST = 'UPDATE_ACCESSORIES_PO_REQUEST';
export const UPDATE_ACCESSORIES_PO_SUCCESS = 'UPDATE_ACCESSORIES_PO_SUCCESS';
export const UPDATE_ACCESSORIES_PO_FAILURE = 'UPDATE_ACCESSORIES_PO_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_ACCESSORIES_PO_REQUEST = 'FETCH_SINGLE_ACCESSORIES_PO_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_PO_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_PO_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_PO_FAILURE = 'FETCH_SINGLE_ACCESSORIES_PO_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_ACCESSORIES_PO_REQUEST = 'DELETE_ACCESSORIES_PO_REQUEST';
export const DELETE_ACCESSORIES_PO_SUCCESS = 'DELETE_ACCESSORIES_PO_SUCCESS';
export const DELETE_ACCESSORIES_PO_FAILURE = 'DELETE_ACCESSORIES_PO_FAILURE';

// USERFORM RESET

export const ACCESSORIES_PO_USERFORM_RESET = 'ACCESSORIES_PO_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_ACCESSORIES_PO_DETAILS = 'NAVIGATE_ACCESSORIES_PO_DETAILS';
// navigate to company component
export const NAVIGATE_ACCESSORIES_PO = 'NAVIGATE_ACCESSORIES_PO';

export const RESET_ACCESSORIES_PO_INVOICE = 'RESET_ACCESSORIES_PO_INVOICE';

export const SET_GRID_PAGE_INDEX_ACCESSORIES_PO = 'SET_GRID_PAGE_INDEX_ACCESSORIES_PO';

export const ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB';

export const ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

//FETCH INVOICE DATA
export const FETCH_ACCESSORIES_PO_INVOICE_REQUEST = 'FETCH_ACCESSORIES_PO_INVOICE_REQUEST';
export const FETCH_ACCESSORIES_PO_INVOICE_SUCCESS = 'FETCH_ACCESSORIES_PO_INVOICE_SUCCESS';
export const FETCH_ACCESSORIES_PO_INVOICE_FAILURE = 'FETCH_ACCESSORIES_PO_INVOICE_FAILURE';

export const DELETE_BTN_UPDATE_API_REQUEST = 'DELETE_BTN_UPDATE_API_REQUEST';
export const DELETE_BTN_UPDATE_API_SUCCESS = 'DELETE_BTN_UPDATE_API_SUCCESS';
export const DELETE_BTN_UPDATE_API_FAILURE = 'DELETE_BTN_UPDATE_API_FAILURE';

export const CLOSE_BTN_POST_REQUEST_ACCESSORIES = 'CLOSE_BTN_POST_REQUEST_ACCESSORIES'
export const CLOSE_BTN_POST_SUCCESS_ACCESSORIES = 'CLOSE_BTN_POST_SUCCESS_ACCESSORIES'
export const CLOSE_BTN_POST_FAILURE_ACCESSORIES = 'CLOSE_BTN_POST_FAILURE_ACCESSORIES'

export const CHECK_ALL_UPDATE_REQUEST_ACCESSORIES = 'CHECK_ALL_UPDATE_REQUEST_ACCESSORIES';
export const CHECK_ALL_UPDATE_SUCCESS_ACCESSORIES = 'CHECK_ALL_UPDATE_SUCCESS_ACCESSORIES';
export const CHECK_ALL_UPDATE_FAILURE_ACCESSORIES = 'CHECK_ALL_UPDATE_FAILURE_ACCESSORIES';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_ACCESSORIES_PO_PRINT = 'NAVIGATE_ACCESSORIES_PO_PRINT';